import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { TermsPolicyDialogComponent } from './terms-policy-dialog.component';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { IonicModule } from '@ionic/angular';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, "../assets/i18n/", ".json");
}


@NgModule({
  declarations: [TermsPolicyDialogComponent],
  imports: [
    CommonModule,
    IonicModule,
    MatDialogModule,
    
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    })
  ],
  exports : [TermsPolicyDialogComponent]
})
export class TermsPolicyDialogModule { }
